<ng-container *ngIf="visible">
  <div class="btp-backdrop" (click)="close()"></div>
  <div class="btp-modal">

    <div class="btp-title">🔵 Bluetooth Printer</div>

    <div class="btp-saved" *ngIf="savedAddress">
      <span class="btp-saved-icon">✅</span>
      <div class="btp-saved-text">
        <span class="btp-saved-label">Saved printer</span>
        <span class="btp-saved-addr">{{ savedAddress }}</span>
      </div>
    </div>

    <!-- Native Android: classic BT device list -->
    <ng-container *ngIf="btService.isNative">
      <div class="btp-loading" *ngIf="loading">Scanning paired devices…</div>
      <div class="btp-error"  *ngIf="error && !loading">{{ error }}</div>
      <div class="btp-list"   *ngIf="!loading">
        <div class="btp-item" *ngFor="let d of devices" (click)="selectDevice(d)">
          <div class="btp-dev-name">{{ d.name || 'Unknown device' }}</div>
          <div class="btp-dev-addr">{{ d.address }}</div>
        </div>
        <div class="btp-empty" *ngIf="!devices.length && !error">
          No paired devices found.<br>Pair your printer in Android Settings → Bluetooth first.
        </div>
      </div>
    </ng-container>

    <!-- Web browser: Web Bluetooth info -->
    <ng-container *ngIf="!btService.isNative">
      <div class="btp-web-info" *ngIf="btService.hasWebBluetooth">
        <p>Web Bluetooth (BLE) connects when you click <strong>📶 BT Web</strong> in the print modal.</p>
        <p *ngIf="savedWebBtId" class="btp-web-saved">Web device saved — will reconnect automatically.</p>
        <p *ngIf="!savedWebBtId" class="btp-web-none">No web BT device saved yet. Click <strong>📶 BT Web</strong> in any print dialog to pair.</p>
      </div>
      <div class="btp-web-info btp-web-unavail" *ngIf="!btService.hasWebBluetooth">
        <p>Web Bluetooth is not supported in this browser.</p>
        <p>Use <strong>Chrome</strong> or <strong>Edge</strong> over HTTPS, or install the <strong>Milkomatic Android app</strong> for Classic Bluetooth printing.</p>
      </div>
    </ng-container>

    <div class="btp-footer">
      <button class="btp-btn-cancel" (click)="close()">Close</button>
      <button class="btp-btn-reset"  (click)="reset()" *ngIf="savedAddress || savedWebBtId">Reset Saved Printer</button>
    </div>
  </div>
</ng-container>
